<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-tabs v-model="tab" class="elevation-2" centered="centered" grow="grow">
				<v-tabs-slider></v-tabs-slider>

				<v-tab href="#tab-1">
					البيانات الأساسية
					<v-icon left>mdi-account</v-icon>
				</v-tab>

				<v-tab href="#tab-2">
					الإشعارات
					<v-icon left>mdi-bell</v-icon>
				</v-tab>

				<v-tab-item value="tab-1">
					<v-card flat tile>
						<v-card-text>
							<v-row>
								<v-col cols="12" sm="8" md="9">
									<div>
										<v-icon right size="24">mdi-account</v-icon>
										<span>
											<b>اسم المستخدم:</b>
											{{ profile.displayName }}
										</span>
									</div>
									<div>
										<v-icon right size="24">mdi-card-account-details</v-icon>
										<span>
											<b>الاسم:</b>
											{{ profile.fullName }}
										</span>
									</div>
									<div>
										<v-icon right size="24">mdi-account-multiple</v-icon>
										<span>
											<b>المجموعة:</b>
											{{ profile.userGroup }}
										</span>
									</div>
									<div>
										<v-icon right size="24">mdi-at</v-icon>
										<span>
											<b>البريد الإلكتروني:</b>
											{{ profile.email }}
										</span>
									</div>
									<div>
										<v-icon right size="24">mdi-human-male-female</v-icon>
										<span>
											<b>الجنس:</b>
											{{ profile.gender }}
										</span>
									</div>
									<div>
										<v-icon right size="24">mdi-cellphone-android</v-icon>
										<span>
											<b>رقم الجوال:</b>
											&nbsp;
											<span dir="ltr">
												{{ profile.phoneNumber }}
											</span>
										</span>
									</div>
									<div>
										<v-row dense>
											<v-col class="shrink">
												<v-icon right size="24">mdi-doctor</v-icon>
											</v-col>
											<v-col class="shrink pt-3">
												<b>التخصص:</b>
											</v-col>
											<v-col class="expand">
												<v-select
													v-model="profile.specialties"
													:items="allSpecialties"
													item-text="name"
													item-value="id"
													outlined
													dense
													hide-details
												>
													<template #item="{ item }">
														<v-list-item-content>
															<v-list-item-title>
																{{ item.name }}
															</v-list-item-title>
															<v-list-item-subtitle v-if="item.femName" class="text-caption">
																{{ item.femName }}
															</v-list-item-subtitle>
														</v-list-item-content>
													</template>
												</v-select>
											</v-col>
											<v-col class="shrink">
												<v-icon color="success" size="24" @click="updateSpeciality">mdi-check-circle</v-icon>
											</v-col>
										</v-row>
									</div>

									<v-card outlined class="my-3">
										<v-data-table hide-default-footer :headers="headers" :items="communications" :items-per-page="-1" dense>
											<template #[`item.value`]="{ item }">
												<div v-if="item.isEdit">
													<v-form v-model="item.valid">
														<v-text-field v-model="item.value" :disabled="item.isLoading" :rules="[rules.required]" dir="ltr"></v-text-field>
													</v-form>
												</div>
												<div v-else dir="ltr">{{ item.value }}</div>
											</template>

											<template #[`item.actions`]="{ item }">
												<v-form v-model="item.valid">
													<v-tooltip v-if="item.exist" bottom>
														<template #activator=" {on} ">
															<v-btn icon medium :disabled="item.isLoading" v-on="on" @click="removeCommunication(item)">
																<v-icon color="primary">mdi-comment-remove</v-icon>
															</v-btn>
														</template>
														<span>حذف</span>
													</v-tooltip>

													<v-tooltip v-else-if="item.isEdit == false" bottom>
														<template #activator=" {on} ">
															<v-btn icon medium :disabled="item.isLoading" v-on="on" @click="enableEditCommunication(item)">
																<v-icon color="primary">mdi-comment-edit</v-icon>
															</v-btn>
														</template>
														<span>إضافة</span>
													</v-tooltip>

													<v-tooltip v-else bottom>
														<template #activator=" {on} ">
															<v-btn icon medium :disabled="item.isLoading || !item.valid" v-on="on" @click="enableEditCommunication(item)">
																<v-icon color="success">mdi-comment-check</v-icon>
															</v-btn>
														</template>
														<span>حفظ</span>
													</v-tooltip>
												</v-form>
											</template>
										</v-data-table>
									</v-card>
								</v-col>

								<v-col cols="12" sm="4" md="3">
									<v-img contain class="mx-auto" aspect-ratio="1" max-width="300" :src="profile.avatar">
										<template #placeholder>
											<v-row class="fill-height ma-0" align="center" justify="center">
												<v-progress-circular indeterminate color="primary"></v-progress-circular>
											</v-row>
										</template>
									</v-img>
								</v-col>

								<v-col cols="12" class="text-center pb-0">
									<v-row dense>
										<v-col cols="12" sm="6" md="3">
											<v-btn block rounded color="primary" :disabled="!privs.changeEmail" @click="showModifyEmailDialog">
												تغيير البريد الإلكتروني
											</v-btn>
										</v-col>
										<v-col cols="12" sm="6" md="3">
											<v-btn block rounded color="primary" :disabled="!privs.changePhone" @click="showModifyPhoneDialog">تغيير رقم الهاتف</v-btn>
										</v-col>
										<v-col cols="12" sm="6" md="3">
											<v-btn block rounded color="primary" :disabled="!privs.changePassword" @click="showModifyPasswordDialog">تغيير كلمة المرور</v-btn>
										</v-col>
										<v-col cols="12" sm="6" md="3">
											<v-btn block rounded color="primary" :disabled="!privs.changeAvatar" @click="showModifyAvatarDialog">تغيير الصورة الشخصية</v-btn>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-tab-item>

				<v-tab-item value="tab-2">
					<v-card flat tile>
						<v-card-text>
							<v-row>
								<v-col cols="12" md="6">
									<v-row align="center" no-gutters>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
										<v-col cols="auto" class="pa-0 text-h6">المحتوى</v-col>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
									</v-row>
									<v-switch
										v-model="notifications.courses"
										:loading="notifications.courses == null"
										:class="{'font-weight-black': notifications.courses}"
										label="الدورات التدريبية"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notifications.news"
										:loading="notifications.news == null"
										:class="{'font-weight-black': notifications.news}"
										label="الأخبار العامة"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notifications.switch"
										:loading="notifications.switch == null"
										:class="{'font-weight-black': notifications.switch}"
										label="النقل ببديل"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notifications.events"
										:loading="notifications.events == null"
										:class="{'font-weight-black': notifications.events}"
										label="الفعاليات"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notifications.jobs"
										:loading="notifications.jobs == null"
										:class="{'font-weight-black': notifications.jobs}"
										label="الوظائف الطبية"
										hide-details
										inset
									></v-switch>
								</v-col>
								<v-col cols="12" md="6">
									<v-row align="center" no-gutters>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
										<v-col cols="auto" class="pa-0 text-h6">طريقة الإشعار</v-col>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
									</v-row>
									<v-switch
										v-model="notificationsMethods.notiByEmail"
										:loading="notificationsMethods.notiByEmail == null"
										:class="{'font-weight-black': notificationsMethods.notiByEmail}"
										label="رسائل البريد الإلكتروني"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notificationsMethods.notiByPhone"
										:loading="notificationsMethods.notiByPhone == null"
										:class="{'font-weight-black': notificationsMethods.notiByPhone}"
										label="إشعارات الهاتف الجوال"
										hide-details
										inset
									></v-switch>
									<v-switch
										v-model="notificationsMethods.notiByWeb"
										:loading="notificationsMethods.notiByWeb == null"
										:class="{'font-weight-black': notificationsMethods.notiByWeb}"
										label="إشعارات داخل الموقع"
										hide-details
										inset
									></v-switch>
								</v-col>
								<v-col cols="12">
									<v-row align="center" no-gutters>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>
										<v-col cols="auto" class="pa-0 text-h6">تخصيص الإشعارات</v-col>
										<v-col cols="expand" class="py-0 px-4">
											<v-divider></v-divider>
										</v-col>

										<v-col cols="12">
											<v-row>
												<v-col cols="12" md="6">
													<v-autocomplete
														v-model="tags.cities"
														hide-details
														outlined
														:items="allCities"
														label="على حسب المدينة"
														multiple
														chips
														item-text="name"
														item-value="cityID"
														clearable
													></v-autocomplete>
												</v-col>

												<v-col cols="12" md="6">
													<v-autocomplete
														v-model="tags.specialties"
														hide-details
														outlined
														:items="allSpecialties"
														label="على حسب التخصص"
														multiple
														chips
														item-text="name"
														item-value="specialtiesID"
														clearable
													></v-autocomplete>
												</v-col>
											</v-row>

											<v-row justify="center">
												<v-col cols="12" sm="6" md="3" class="pb-0 pt-6">
													<v-btn rounded block color="primary" @click="saveNotifications">حفظ</v-btn>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-container>

		<v-dialog v-model="modifyEmailDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث البريد الإلكتروني</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="newEmail"
									outlined
									hide-details="auto"
									label="البريد الإلكتروني"
									:rules="[rules.required, rules.email]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="updateEmail">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyPasswordDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث كلمة المرور</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid2">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="currentPassword"
									outlined
									hide-details="auto"
									label="كلمة المرور الحالية"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>

							<v-col cols="12">
								<v-text-field
									v-model="newPassword"
									outlined
									hide-details="auto"
									label="كلمة المرور الجديدة"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="updatePassword">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyPhoneDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث رقم الهاتف</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid3">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="newPhone"
									outlined
									hide-details="auto"
									label="رقم الهاتف"
									placeholder="+966500000000"
									:rules="[rules.required, rules.mobile]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid3" :loading="loading" @click="updatePhone">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyAvatarDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث الصورة الشخصية</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid4">
						<v-row>
							<v-col cols="12">
								<v-file-input
									v-model="newAvatar"
									outlined
									hide-details="auto"
									label="الصورة الجديدة"
									:rules="[rules.required]"
								></v-file-input>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid4" :loading="loading" @click="updateAvatar">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			tab: "tab-1",
			profile: {
				id: -1,
				displayName: "...",
				fullName: "...",
				email: "...",
				gender: "...",
				phoneNumber: "...",
				userGroup: "...",
				avatar: null,
				communications: [],
				specialties: null
			},
			notifications: {},
			notificationsMethods: {},
			tags: {
				cities: [],
				specialties: []
			},
			allCities: [],
			allSpecialties: [],
			newEmail: null,
			modifyEmailDialog: false,
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			loading: false,
			newPhone: null,
			modifyPhoneDialog: false,
			newPassword: null,
			currentPassword: null,
			modifyPasswordDialog: false,
			newAvatar: null,
			modifyAvatarDialog: false,
			oldNoti: [],
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'حسابي', disabled: true }
			],

			headers: [
				{ value: "name", text: "موقع التواصل" },
				{ value: "value", text: "الرابط" },
				{ value: "actions", text: "عمليات", align: "end" }
			],
			communications: [],
		};
	},
	mounted() {
		this.getPrivileges();
		this.getMyProfile();
		this.getSettings();
		this.getSpecialties();
		this.getCities();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/profileIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getMyProfile() {
			client
				.get("/api/myprofile/me")
				.then(response => {
					console.log(response);
					this.profile = response.data.data;
					
					if (this.profile.gender == "M") {
						this.profile.gender = "ذكر"
					} else if (this.profile.gender == "F") {
						this.profile.gender = "انثى"
					}

					if (this.profile.avatar == null || this.profile.avatar == "" || this.profile.avatar == "https://ertiqa.svod.app/storage") {
						if (this.profile.gender == "F") {
							this.profile.avatar = "https://www.w3schools.com/w3images/avatar4.png"
						} else {
							this.profile.avatar = "https://www.w3schools.com/w3images/avatar2.png"
						}
					}

					this.getCommunications();
				})
				.catch(err => {
					console.log(err);
				});
		},
		removeCity(index) {
			console.log(index);
		},
		showModifyEmailDialog() {
			this.modifyEmailDialog = true;
		},
		showModifyPasswordDialog() {
			this.modifyPasswordDialog = true;
		},
		showModifyPhoneDialog() {
			this.modifyPhoneDialog = true;
		},
		showModifyAvatarDialog() {
			this.modifyAvatarDialog = true;
		},
		updateEmail() {
			this.loading = true;
			client
				.post("/api/myprofile/changemyemail", { email: this.newEmail })
				.then(response => {
					console.log(response);
					this.modifyEmailDialog = false;
					this.profile.email = "" + this.newEmail;
					this.$store.dispatch("notify", {
						message: "تم تحديث البريد الإلكتروني",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث البريد الإلكتروني",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updatePhone() {
			this.loading = true;
			client
				.post("/api/myprofile/changemyphonenumber", {
					phoneNumber: this.newPhone
				})
				.then(response => {
					console.log(response);
					this.modifyPhoneDialog = false;
					this.profile.phoneNumber = "" + this.newPhone;
					this.$store.dispatch("notify", {
						message: "تم تحديث رقم لهاتف",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث رقم لهاتف",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updatePassword() {
			this.loading = true;
			var data = {
				currentPassword: this.currentPassword,
				newPassword: this.newPassword,
				newPassword_Confirmation: this.newPassword
			};

			client
				.post("/api/myprofile/changemyPassword", data)
				.then(response => {
					console.log(response);
					this.modifyPasswordDialog = false;
					this.$store.dispatch("notify", {
						message: "تم تحديث كلمة المرور",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث كلمة المرور",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateAvatar() {
			this.loading = true;

			var data = new FormData();
			data.append("name", "avatar");
			data.append("description", "avatar");
			data.append("attachment", this.newAvatar);

			client
				.post("/api/myprofile/changemyavatar", data)
				.then(response => {
					console.log(response);
					this.modifyAvatarDialog = false;
					this.profile.avatar = "" + this.newAvatar;
					this.$store.dispatch("notify", {
						message: "تم تحديث الصورة الشخصية",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث الصورة الشخصية",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		saveNotifications() {
			this.loading = true;

			client
				.post(
					"/api/myprofile/changenotfimethod",
					this.notificationsMethods
				)
				.then(response => {
					console.log(response);
					this.$store.dispatch("notify", {
						message: "تم تحديث",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث",
						color: "error"
					});
				});

			var addData = {
				cities: [],
				specialities: [],
				sections: []
			};

			var removeData = {
				cities: [],
				specialities: [],
				sections: []
			};

			var sections = ["courses", "news", "events", "jobs", "switch"];
			sections.forEach(section => {
				if (this.notifications[section]) {
					if (this.oldNoti.sections.indexOf(section) == -1) {
						addData.sections.push(section);
					}
				} else {
					if (this.oldNoti.sections.indexOf(section) != -1) {
						removeData.sections.push(section);
					}
				}
			});

			this.allCities.forEach(city => {
				var cityID = city.cityID;
				var selected = this.tags.cities;
				if (selected.indexOf(cityID) != -1) {
					if (this.oldNoti.cities.indexOf(cityID) == -1) {
						addData.cities.push(cityID);
					}
				} else {
					if (this.oldNoti.cities.indexOf(cityID) != -1) {
						removeData.cities.push(cityID);
					}
				}
			});

			this.allSpecialties.forEach(speciality => {
				var specID = speciality.specialtiesID;
				var selected = this.tags.specialties;
				if (selected.indexOf(specID) != -1) {
					if (this.oldNoti.specialities.indexOf(specID) == -1) {
						addData.specialities.push(specID);
					}
				} else {
					if (this.oldNoti.specialities.indexOf(specID) != -1) {
						removeData.specialities.push(specID);
					}
				}
			});

			removeData.sections.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.sections.indexOf(notif);
						this.oldNoti.sections.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			removeData.cities.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.cities.indexOf(notif);
						this.oldNoti.cities.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			removeData.specialities.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.specialities.indexOf(notif);
						this.oldNoti.specialities.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			client
				.post("/api/myprofile/setnotfifavorites", addData)
				.then(response => {
					console.log(response);
					addData.sections.forEach(item => {
						this.oldNoti.sections.push(item);
					});
					addData.cities.forEach(item => {
						this.oldNoti.cities.push(item);
					});
					addData.specialities.forEach(item => {
						this.oldNoti.specialities.push(item);
					});
					this.$store.dispatch("notify", {
						message: "تم تحديث",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث",
						color: "error"
					});
				});
		},
		getSettings() {
			client
				.get("/api/myprofile/getnotfimethod")
				.then(response => {
					console.log(response);
					this.notificationsMethods = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});

			client
				.get("/api/myprofile/getnotfifavorite")
				.then(response => {
					console.log(response);
					var noti = response.data.data;
					this.oldNoti = noti;

					if (!noti.sections) {
						noti.sections = [];
					}

					this.notifications = {
						courses: noti.sections.indexOf("courses") != -1,
						news: noti.sections.indexOf("news") != -1,
						events: noti.sections.indexOf("events") != -1,
						jobs: noti.sections.indexOf("jobs") != -1,
						switch: noti.sections.indexOf("switch") != -1
					};

					if (noti.cities && noti.cities.length) {
						this.tags.cities = [...noti.cities];
					} else {
						noti.cities = [];
						this.tags.cities = [];
					}
					if (noti.specialities && noti.specialities.length) {
						this.tags.specialties = [...noti.specialities];
					} else {
						noti.specialities = [];
						this.tags.specialties = [];
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getSpecialties() {
			client
				.get("/api/specialties/all")
				.then(response => {
					this.allSpecialties = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities() {
			client
				.get("/api/location/cities")
				.then(response => {
					this.allCities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCommunications() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.communications = response.data
						.filter(communication => {
							const allowed = ['facebook', 'linkedin', 'telegram', 'twitter', 'whatsapp'];
							return allowed.indexOf(communication.communicationTypeID) != -1;
						})
						.map(communication => {
							const thisCom = this.profile.communications.find(com => com.name == communication.name);
							communication.isEdit = false;
							communication.valid = false;
							if (thisCom) {
								communication.exist = true;
								communication.id = thisCom.id;
								communication.value = thisCom.value;
							} else {
								communication.exist = false;
								communication.id = null;
							}
							return communication
						});
					this.loading = false;
				})
		},
		enableEditCommunication(item) {
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.value = item.initialProfilesPath
				item.isEdit = true;
			}
		},
		updateInfo(item){
			item.isLoading = true;

			clientNotifier
				.post("/api/myprofile/newCommunication", item)
				.then(response => {
					item.isEdit = false;
					item.exist = true;
					item.id = response.data.data.id;
					item.value = response.data.data.value;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		removeCommunication(item){
			item.isLoading = true;

			clientNotifier
				.delete("/api/myprofile/deletecommunication/" + item.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					item.isEdit = false;
					item.exist = false;
					item.id = null;
					item.value = null;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		updateSpeciality() {
			this.loading = true;
			const data = {
				specialtiesID: this.profile.specialties
			}
			clientNotifier
				.post("/api/myprofile/changeMySpecialties", data)
				.then(response => {
					console.log(response)
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
span {
	vertical-align: center;
}
</style>